import React from 'react';
import { CheckCircle } from 'lucide-react';

export const StepIndicator = ({ steps, currentStep }) => {
  return (
    <div className="relative pt-2">
      <div className="absolute top-8 left-0 right-0 h-0.5 bg-slate-200">
        <div 
          className="h-full bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 transition-all duration-700 ease-out"
          style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
        />
      </div>
      <div className="relative flex justify-between">
        {steps.map((step, index) => {
          const stepNum = index + 1;
          const isCompleted = currentStep > stepNum;
          const isCurrent = currentStep === stepNum;
          return (
            <div key={step.id} className="flex flex-col items-center">
              <div className={`
                relative w-12 h-12 rounded-full flex items-center justify-center transition-all duration-500 z-10
                ${isCompleted 
                  ? 'bg-gradient-to-br from-green-400 to-emerald-600 text-white shadow-lg shadow-green-500/30' 
                  : isCurrent 
                    ? 'bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 text-white shadow-xl shadow-blue-500/40 scale-110 ring-4 ring-blue-200/50' 
                    : 'bg-slate-100 text-slate-400 border-2 border-slate-200'}
              `}>
                {isCompleted ? (
                  <CheckCircle className="h-6 w-6" />
                ) : (
                  <step.icon className={`h-5 w-5 ${isCurrent ? 'animate-pulse' : ''}`} />
                )}
                {isCurrent && (
                  <div className="absolute inset-0 rounded-full bg-white/20 animate-ping" />
                )}
              </div>
              <span className={`mt-3 text-xs font-semibold text-center max-w-[70px] transition-colors ${
                isCurrent ? 'text-blue-600' : isCompleted ? 'text-green-600' : 'text-slate-400'
              }`}>
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const HighTechCard = ({ children, gradient = 'blue', className = '' }) => {
  const gradients = {
    blue: 'from-blue-600 via-indigo-600 to-purple-600',
    green: 'from-emerald-500 via-green-500 to-teal-500',
    orange: 'from-amber-500 via-orange-500 to-red-500',
    purple: 'from-purple-600 via-pink-500 to-rose-500',
    cyan: 'from-cyan-500 via-blue-500 to-indigo-500'
  };
  return (
    <div className={`relative overflow-hidden rounded-2xl ${className}`}>
      <div className={`absolute inset-0 bg-gradient-to-r ${gradients[gradient]} opacity-20`} />
      <div className="absolute inset-[1px] bg-white rounded-2xl" />
      <div className="relative">{children}</div>
    </div>
  );
};
